import { mergeToNewObject } from '../../../util/helpers'
import { WALLET_CREATE, WALLET_RESTORE, WALLET_STORAGE, WALLET_UNLOCK, PASSWORD_CHANGE } from '../../../constants/actions'
import { LOADING_MESSAGES } from '../../../constants/messages'

export const walletProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case WALLET_CREATE.ON_CREATE_WALLET:
      return mergeToNewObject(state, { loading: LOADING_MESSAGES.WALLET_CREATE })

    case WALLET_CREATE.ON_WALLET_CREATED:
      return mergeToNewObject(state, { wallet: extractFromStorage(payload), loading: '', unlocked: true })

    case PASSWORD_CHANGE.ON_PASSWORD_CHANGED_ACTION:
      return mergeToNewObject(state, { wallet: extractFromStorage(payload) })

    case WALLET_RESTORE.ON_WALLET_RESTORED:
      return mergeToNewObject(state, { wallet: extractFromStorage(payload), loading: '', unlocked: false })

    case WALLET_STORAGE.ON_WALLET_FOUND:
      return mergeToNewObject(state, { wallet: extractFromStorage(payload), loading: '', unlocked: false })

    case WALLET_UNLOCK.ON_WALLET_UNLOCKED:
      return mergeToNewObject(state, { loading: '', unlocked: true })

    case WALLET_UNLOCK.ON_LOCK_WALLET:
      return mergeToNewObject(state, { unlocked: false })

    default:
      return state
  }
}

const INITIAL_STATE = {
  wallet: {},
  loading: '',
  unlocked: false
}

function extractFromStorage(storedWallet) {
  return storedWallet && storedWallet.encrypted ? storedWallet : {}
}

// Wallet from storage (locked) should have this represenation
// const wallet = {
//   address,
//   encrypted
// }


// WEBPACK FOOTER //
// ./src/store/reducers/wallet/wallet.js